"use client";

import type { FC, Ref } from "react";
import {
  FlowCard,
  type UIAction,
  useActions,
  AskAITooltipContent,
} from "@huub-web/ui";

import { useTemplates } from "../../hooks/useTemplates";

export interface FlowCardTemplateProps {
  title: string;
  subtitle?: string;
  step?: number;
  icon?: string;
  disabled?: boolean;
  active?: boolean;
  description: string;
  tooltip?: string;
  columns?: "one" | "two";
  action?: UIAction;
  button?: string;
  variant?: "primary" | "secondary";
}

/**
 * @deprecated 💀
 */
export const FlowCardTemplate: FC<
  FlowCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({
  title,
  subtitle,
  step,
  icon,
  disabled,
  active,
  description,
  tooltip,
  columns,
  action,
  button,
  variant = "primary",
  ref,
}) => {
  const { handleAction } = useActions();
  const { lockPrompts, lockUI } = useTemplates();

  const handleClick = () => {
    if (action) {
      handleAction(action);
    }
  };

  const isDisabled = (() => {
    if (action?.type === "prompt") {
      return lockPrompts;
    }
    return lockUI || disabled;
  })();

  return (
    <FlowCard
      ref={ref}
      title={title}
      subtitle={subtitle}
      variant={variant === "primary" ? "primary" : "tertiary"}
      border={variant === "primary" ? "default" : "none"}
      step={step}
      icon={icon}
      onClick={handleClick}
      description={description}
      columns={columns}
      active={active}
      prompt={action?.payload?.prompt}
      disabled={isDisabled}
      button={button}
      tooltip={
        action?.payload && action?.type === "prompt" ? (
          <AskAITooltipContent prompt={action?.payload} />
        ) : (
          tooltip
        )
      }
    />
  );
};
